/**
 * Sora 视频生成工具集
 * 导出所有可用的视频生成工具
 */
import { createVideoFromTextTool } from './createVideoFromText.tool.js';
import { createVideoFromImageTool } from './createVideoFromImage.tool.js';

/**
 * 这是一个工具数组，包含了我们项目中所有可用的工具。
 * 我们的服务器将从这里加载所有功能。
 */
export const allTools = [
  createVideoFromTextTool,
  createVideoFromImageTool,
];